import styled from 'styled-components'

import theme from 'config/theme'

const SelectListActions = styled.div`
  padding: ${theme.spacing.s};
`

export default /** @type any */(SelectListActions)
